// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__Ofqsa","whiteBg":"Loading_whiteBg__3GvG-","fixed":"Loading_fixed__1gpuN","loadingGif":"Loading_loadingGif__37FXa"};